import React from 'react'


export default function Neuro1() {
    return (
       
   
      <div className='section_heading'>
        <h1>Kalpataru <span>BackPain</span> Treatment</h1>
        </div>
    

       
    )
}
